// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "code[data-v-0c972e18]{font-size:.8rem}", ""]);
// Exports
module.exports = exports;
